import script from "./ObjectPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectPreview.vue?vue&type=script&setup=true&lang=ts"

import "./ObjectPreview.vue?vue&type=style&index=0&id=39122696&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39122696"]])

export default __exports__